// extracted by mini-css-extract-plugin
export default {"root":"InlineIntegrationHomePage__root--zc7xR","header":"InlineIntegrationHomePage__header--1Gzhq","datalist":"InlineIntegrationHomePage__datalist--3Rg2w"};